import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '30-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-paper px-5 pb-16 pt-5 sm:pb-20 sm:pt-12" data-id="element-116" data-mp="9lla0zpw82ok">
      <div className="mx-auto max-w-4xl text-center" data-id="element-117" data-mp="4mi47d239sfj">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 rounded-full bg-cta-light px-3 py-1 text-[9px] font-bold uppercase tracking-[0.16em] text-cta-dark sm:px-4 sm:py-1.5 sm:text-[10px]" data-id="element-118" data-mp="4jvvvb7dj8w9">
          Physics &amp; Chemistry Ready-to-Teach™
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mt-3 font-display text-[1.75rem] font-black leading-[1.06] tracking-tight text-ink sm:mt-5 sm:text-[2.75rem] md:text-[3.75rem]" data-id="element-119" data-mp="nekn6v27dksy">
          Solve a Full Year of{' '}
          <span className="text-cta-dark" data-id="element-120" data-mp="3o6kdjcmbi22h">Physics &amp; Chemistry</span> Class in
          Just <span className="italic text-cta-dark" data-id="element-121" data-mp="39b4fyxmj3o1c">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-ink/60 sm:mt-5 sm:text-lg" data-id="element-122" data-mp="3e8wkqs89v4my">
          Join 4,200+ science teachers who stopped improvising. Walk into every
          lab and lesson with everything ready to teach, solve, and inspire.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.18,
        ease: 'easeOut'
      }} className="mx-auto mt-2 max-w-2xl sm:mt-8" data-id="element-123" data-mp="2vgu075sif47f">
          <img src="https://cdn.magicpatterns.com/uploads/p81gbfu3wS9Lsr1Rzu4S32/Diseno-sin-titulo-2026-08-03T132452.210.webp" alt="The Physics & Chemistry Ready-to-Teach pack shown across six printed volumes, desktop, tablet and phone" className="mx-auto max-h-[38vh] w-full object-contain sm:max-h-none" data-id="element-124" data-mp="s2jj7lrcvge8" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.28,
        ease: 'easeOut'
      }} className="mt-1 sm:mt-4" data-id="element-125" data-mp="1b0vv3f9nj4di">
          <CtaButton href="#offer" className="px-6 py-5 text-xs sm:px-9 sm:py-6 sm:text-base" data-id="element-126" data-mp="1126ncfbgz0az" />
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[11px] font-semibold text-ink/50 sm:mt-6 sm:text-sm" data-id="element-127" data-mp="x1nuchxubo77">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-128" data-mp="3hqu2kaecg816" data-mpi={index}>
                <span data-id="element-129" data-mp="3htq03xma4up3">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-130" data-mp="1x783jjm4pjs0">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}